import React from 'react';
import ReactDOM from 'react-dom/client';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <div style={{ fontFamily: 'sans-serif', textAlign: 'center', marginTop: '50px' }}>
      <h1>¡Hola! Tu Frontend ya funciona.</h1>
      <p>Compilado exitosamente en Cloudflare Pages.</p>
    </div>
  </React.StrictMode>
);
